export enum ExportTypesEnum {
    MEALS = 'meals',
    HOMEWORKS = 'homeworks',
    POINTINGS = 'pointings',
    WALLETS = 'wallets',
    ATTESTATIONS_PDF = 'tax_return_documents_pdf',
    ATTESTATIONS_CSV = 'tax_return_documents',
}
